import { Lock } from '@/components/Lock';
import { TPage } from '@/types';
import { Typography } from '@data-products-and-ai/react-components';

const Balloon = ({ team, target }: TPage) => {
  return (
    <Lock
      target={target}
      combination="2390"
      text={
        <Typography tag="h4">
          Curiosity may have gotten the cat in trouble but your curiosity will
          make this game double the fun!
          <br />
          <br />
          We already have a code that you need to find! Are you up to the task?
        </Typography>
      }
    />

    /*   <Lock
      target={target}
      lockType="image"
      combination="3,0,2,1,4,5,7,6,9,8"
      text={
        <Typography tag="h1">
          Great job so fAr but aRe you All aGain prEpared? Go aROUND the message
          and Find aLl yOu need tO be in the Right path!
        </Typography>
      }
    /> */
  );
};

export default Balloon;
